"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHeadlineProperty = exports.headlinePropertyDefinition = void 0;
exports.headlinePropertyDefinition = {
    view: { label: 'Headline' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['headline-text', 'headline-chapter'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'headline',
};
const isHeadlineProperty = (prop) => {
    return prop.name === exports.headlinePropertyDefinition.name;
};
exports.isHeadlineProperty = isHeadlineProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVhZGxpbmUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9oZWFkbGluZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDBCQUEwQixHQUFHO0lBQ3hDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxVQUFVLEVBQUU7SUFDM0IsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRSxDQUFDLGVBQWUsRUFBRSxrQkFBa0IsQ0FBQztTQUNoRDtLQUNGO0lBQ0QsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxVQUFVO0NBQ2UsQ0FBQTtBQUkxQixNQUFNLGtCQUFrQixHQUFHLENBQUMsSUFBa0IsRUFBNEIsRUFBRTtJQUNqRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssa0NBQTBCLENBQUMsSUFBSSxDQUFBO0FBQ3RELENBQUMsQ0FBQTtBQUZZLFFBQUEsa0JBQWtCLHNCQUU5QiJ9